import { Routes, Route, BrowserRouter } from "react-router-dom";
import Login from "../pages/Login";
import Signup from "../pages/signup";
import Verfication from "../pages/Verfication/VerifyMobile";
import VerficationSuccess from "../pages/Verfication/Success";
import VerficationError from "../pages/Verfication/Error";
import AgreeTerms from "../pages/Verfication/AgreeTerms";
import Dashboard from "../pages/DashBoard";
import Campaigns from "../pages/DashBoard/Campaigns";
import CampaignDetails from "../pages/DashBoard/CampaignDetails";
import TargetUser from "../pages/DashBoard/targetUser";
import Profile from "../pages/Profile";
import FreeuserCampaignFlow from "../pages/CampaignFlow/FreeuserCampaignFlow";
import MyOrganization from "../pages/DashBoard/myOrganization";
import ResetPassword from "../pages/resetPassword";
import Emailsentpage from "../pages/Emailsentpage";       
import PrivateRoute from "./PrivateRoute";
import LoginTemplate from "../pages/LoginTemplate";
import Conversations from "../pages/DashBoard/Conversations";
import ConversationDetail from "../pages/DashBoard/ConversationDetail";
import Training from "../pages/Training";

const Routers = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Login />} />
      </Routes>

      <Routes>
        <Route path='/signup' element={<Signup />} />
      </Routes>

      <Routes>
        <Route path='/emailsent' element={<Emailsentpage />} />
      </Routes>

      <Routes>
        <Route path='/resetpassword' element={<ResetPassword />} />
      </Routes>

      <Routes>
        <Route path='/termsagree' element={<AgreeTerms />} />
      </Routes>

      <Routes>
        <Route path='/verfication' element={<Verfication />} />
      </Routes>

      <Routes>
        <Route path='/success' element={<VerficationSuccess />} />
      </Routes>

      <Routes>
        <Route path='/error' element={<VerficationError />} />
      </Routes>

      <Routes>
        <Route path='/login-template' element={<LoginTemplate />} />
      </Routes>

      <Routes>
        <Route path='/training/:clickid' element={<Training />} />
      </Routes>
      {/* {private Routes} */}

      <Routes>
        <Route
          path='/profile'
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
      </Routes>

      <Routes>
        <Route
          path='/dashboard/overview'
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
      </Routes>

      <Routes>
        <Route
          path='/dashboard/my-campaigns'
          element={
            <PrivateRoute>
              <Campaigns />
            </PrivateRoute>
          }
        />
        <Route
          path='/dashboard/my-campaigns/:id'
          element={
            <PrivateRoute>
              <CampaignDetails />
            </PrivateRoute>
          }
        />
      </Routes>

      <Routes>
        <Route
          path='/dashboard/conversations'
          element={
            <PrivateRoute>
              <Conversations />
            </PrivateRoute>
          }
        />
        <Route
          path='/dashboard/conversations/:id'
          element={
            <PrivateRoute>
              <ConversationDetail />
            </PrivateRoute>
          }
        />
      </Routes>

      <Routes>
        <Route
          path='/dashboard/target-users'
          element={
            <PrivateRoute>
              <TargetUser />
            </PrivateRoute>
          }
        />
      </Routes>
      <Routes>
        <Route
          path='/campaignflow'
          element={
            <PrivateRoute>
              <FreeuserCampaignFlow />
            </PrivateRoute>
          }
        />
      </Routes>
      <Routes>
        <Route
          path='/myorganization'
          element={
            <PrivateRoute>
              <MyOrganization />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Routers;
